import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default settings (fallback)
const DEFAULT_SETTINGS = {
  business_name: "BOXVERRA",
  business_legal_name: "BOXVERRA, LLC",
  tagline: "Luxury Collectibles",
  email: "support@boxverra.com",
  legal_email: "legal@boxverra.com",
  phone: "+1 (800) 123-4567",
  address: {
    street: "Beverly Hills",
    city: "Los Angeles",
    state: "CA",
    zip: "90210",
    country: "United States"
  },
  social_links: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    twitter: "https://twitter.com"
  },
  currency: "USD",
  currency_symbol: "$"
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/site-settings/`);
        setSettings({ ...DEFAULT_SETTINGS, ...response.data });
      } catch (error) {
        console.error('Failed to fetch site settings:', error);
        // Use defaults on error
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  // Helper to get formatted address
  const getFullAddress = () => {
    const addr = settings.address;
    return `${addr.street}, ${addr.city}, ${addr.state} ${addr.zip}`;
  };

  const getAddressLines = () => {
    const addr = settings.address;
    return [
      settings.business_legal_name,
      addr.street,
      `${addr.city}, ${addr.state} ${addr.zip}`
    ];
  };

  return (
    <SiteSettingsContext.Provider value={{ 
      settings, 
      loading, 
      getFullAddress,
      getAddressLines
    }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within SiteSettingsProvider');
  }
  return context;
};
